module.exports = __webpack_public_path__ + "media/customizations/avimor/logo-81c5cec82cafd248d82d08aec6549222.png";